<template>
    <div class="relative h-input w-full min-w-input rounded-input text-gray-600 focus-within:text-gray-400">
        <input
            ref="input"
            :value="modelValue"
            class="muval-input peer w-full rounded-muval-1 border border-muval-gray-4 bg-white pl-10 pr-8 text-sm placeholder-[#999999] transition dark:bg-gray-800"
            :class="{ '!border-focus': $props.search && highlightOnValue }"
            :placeholder="placeholder"
            autocomplete="off"
            @change="!onInput && $emit('update:modelValue', $event.target.value)"
            @input="onInput && $emit('update:modelValue', $event.target.value)"
        />
        <SvgIcon
            name="system-search"
            class="absolute left-2 top-1/2 size-5 -translate-y-1/2 text-muval-gray-3 transition-colors peer-focus:text-focus"
        />
        <SvgIcon
            v-if="modelValue"
            name="system-close"
            class="absolute right-2 top-1/2 size-5 -translate-y-1/2 cursor-pointer text-muval-gray-3 hover:text-black"
            @click="clearInput"
        />
    </div>
</template>

<script setup>
defineProps({
    label: {
        type: [String, null],
        default: null,
    },
    modelValue: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        default: 'Search',
    },
    highlightOnValue: {
        type: Boolean,
        required: false,
        default: false,
    },
    onInput: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const input = ref();

const clearInput = () => {
    emit('update:modelValue', '');
};

defineExpose({
    focus: () => {
        input.value.focus();
    },
    highlight: () => {
        input.value.select();
    },
});
</script>

<style scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
}
</style>
